/**
 * LiveKit remote participant helpers for AI interviews.
 * Candidates join as `candidate-{email}` (see server generateLiveKitToken).
 */

/**
 * Strict match: agent left / interview lifecycle (avoid treating egress or random remotes as the agent).
 * @param {{ identity?: string } | null | undefined} participant
 */
export function isLikelyInterviewAgentParticipant(participant) {
  const identity = participant?.identity;
  if (!identity || typeof identity !== 'string') return false;
  const id = identity.toLowerCase();
  if (id.startsWith('candidate-')) return false;
  if (id.includes('egress') || id.startsWith('eg_')) return false;
  if (identity.startsWith('EG_')) return false;
  return id === 'agent' || id.includes('agent') || id.startsWith('agent-');
}

/**
 * Lenient: attach interviewer audio / "ready" UI — never skip TTS because identity was empty.
 * @param {{ identity?: string } | null | undefined} participant
 */
export function shouldAttachRemoteInterviewerAudioTrack(participant) {
  if (!participant) return false;
  const raw = participant.identity;
  if (raw == null) return true;
  if (typeof raw !== 'string') return true;
  const identity = raw.trim();
  if (identity === '') return true;
  const id = identity.toLowerCase();
  if (id.startsWith('candidate-')) return false;
  if (id.includes('egress') || id.startsWith('eg_')) return false;
  if (identity.startsWith('EG_')) return false;
  return true;
}
